import { render, staticRenderFns } from "./initTrial.vue?vue&type=template&id=b1a100d0&scoped=true"
import script from "./initTrial.vue?vue&type=script&lang=js"
export * from "./initTrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a100d0",
  null
  
)

export default component.exports